// Create a new file: /components/workflow/StructuralConditionalNode.jsx

import React from 'react';
import { Handle } from 'reactflow';
import { Network } from 'lucide-react'; // Diamond-like icon

const statusStyles = {
    idle: "border-zinc-500",
    pending: "border-yellow-400",
    queued: "border-blue-400",
    failed: "border-red-500",
    success: "border-green-500",
    running: "animate-[pulse_1s_infinite] border-green-500",
    approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
    diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
};

const StructuralConditionalNode = ({id, data }) => {
    const status = data?.status || "idle";
    const selectedFieldName = data.selectedConditionPath?.split('.').pop() || 'Not Configured';

    return (
        <div className="relative w-48 h-48 flex items-center justify-center">
            {/* Diamond shape wrapper */}
            <div
                className={`w-40 h-40 border text-zinc-100 relative transform rotate-45 bg-zinc-800 shadow-md ${statusStyles[status]}`}
            >
                {/* Content inside diamond, rotated back */}
                <div className="transform -rotate-45 flex flex-col items-center justify-center h-full text-center p-2">
                    <Network className="text-purple-400 mb-1" size={24} />
                    <h3 className="font-bold text-base text-white">Condition</h3> {id}
                    <p className="text-xs text-slate-300 truncate w-full" title={selectedFieldName}>
                        On: {selectedFieldName}
                    </p>
                </div>
            </div>

            {/* Input handle */}
            <Handle
                type="target"
                position="left"
                className="!bg-yellow-400"
                style={{ left: "-5px", top: "50%" }}
            />
            {/* 'true' output handle */}
            <Handle
                type="source"
                position="right"
                id="true"
                className="!bg-green-400"
                style={{ right: "-5px", top: "50%" }}
            />
            {/* 'false' output handle */}
            <Handle
                type="source"
                position="bottom"
                id="false"
                className="!bg-red-500"
                style={{ bottom: "-5px", left: "50%" }}
            />
        </div>
    );
};

export default StructuralConditionalNode;